export default "__VITE_ASSET__CV5M6LqT__"